export class AccountDrawer extends customElements.get('site-drawer') {
  constructor () {
    super()

    const confirmation = new URL(window.location).searchParams.get(
      'confirmation',
    )
    if (confirmation !== null) {
      this.closest('site-drawers').activeDrawerKey = this.getAttribute('key')
    }
  }
}

customElements.define('account-drawer', AccountDrawer)
